import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css``;

export const title = css`
  font-size: 18px;
  font-weight: 700;
`;

export const grid = css`
  --colAdjust: 3;
  --col-current: max(calc(var(--col-size) - var(--colAdjust)), var(--col-min));
  display: grid;
  grid-template-columns: repeat(var(--col-current), 1fr);
  grid-auto-rows: min-content;
  gap: 1rem;
  overflow: hidden;

  @media screen and (width > ${theme.sizes.screens.sm}) {
    --colAdjust: 2;
  }

  @media screen and (width > ${theme.sizes.screens.md}) {
    --colAdjust: 1;
  }

  @media screen and (width > ${theme.sizes.screens.xl}) {
    --colAdjust: 0;
  }
`;

export const cell = css`
  min-width: 0;
`;
